// Auto generated, DO NOT MODIFY
export enum DBOperationEnum {
    'CREATE_OP' = 'C',
    'UPDATE_OP' = 'U',
    'DELETE_OP' = 'D',
    'SPINNER_OP' = 'S'
}

type DBOperationEnumMap = Record<
    keyof typeof DBOperationEnum,
    {
        keyName: string;
        value: string;
    }
>;

export const DBOperationEnumMap: DBOperationEnumMap = {
    'CREATE_OP': {
        'keyName': 'CREATE_OP',
        'value': 'C'
    },
    'UPDATE_OP': {
        'keyName': 'UPDATE_OP',
        'value': 'U'
    },
    'DELETE_OP': {
        'keyName': 'DELETE_OP',
        'value': 'D'
    },
    'SPINNER_OP': {
        'keyName': 'SPINNER_OP',
        'value': 'S'
    }
};